<template>
  <!-- Default Layout-->
  <div class="min-h-screen flex flex-col">
    <Navbar />
    <div class="flex-grow">
      <slot />
    </div>

    <MarketingFooter/>

  </div>
</template>
<script setup lang="ts">
  import Navbar from '~/components/app/Navbar.vue';
</script>